import * as Yup from 'yup'

const forgotPasswordFormSchema = Yup.object({
  email: Yup.string()
    .email('Debes introducir un correo electrónico')
    .required('Debes introducir un correo electrónico'),
})

export default forgotPasswordFormSchema
